export const ALL_DATA_LISTS = [
  {
    title: "Data Display",
    subMenu: [
      { title: "Typography", link: "/typography" },
      { title: "Colors", link: "/colors" },
      { title: "Chip", link: "/chip" },
      { title: "Badge", link: "/badge" },
      { title: "Tooltip", link: "/tooltip" },
      { title: "List", link: "/list" },
      { title: "Avatar", link: "/avatar" },
      { title: "Icons", link: "/icons" },
      { title: "Table", link: "/table" },
    ],
  },
  {
    title: "Button",
    subMenu: [
      { title: "Buttons", link: "/buttons" },
      { title: "Icon Button", link: "/iconbutton" },
      { title: "Button Group", link: "/buttongroup" },
    ],
  },
  {
    title: "Form Elements",
    subMenu: [
      { title: "TextField", link: "/textfield" },
      { title: "Textarea", link: "/textarea" },
      { title: "Text Editor", link: "/text-editor" },
      { title: "Select", link: "/select" },
      { title: "Switch", link: "/switch" },
      { title: "Radio", link: "/radio" },
      { title: "Checkbox", link: "/checkbox" },
      { title: "Rating", link: "/rating" },
      { title: "Toggle Button", link: "/toggleButton" },
      { title: "File Upload", link: "/fileUpload" },
    ],
  },
  {
    title: "Navigation",
    subMenu: [
      { title: "Menu", link: "/menu" },
      { title: "Breadcrumb", link: "/breadcrumb" },
      { title: "Pagination", link: "/pagination" },
      { title: "Tabs", link: "/tabs" },
      { title: "Stepper", link: "/stepper" },
    ],
  },
  {
    title: "Surface",
    subMenu: [
      { title: "Accordion", link: "/accordion" },
      { title: "Card", link: "/card" },
    ],
  },
  {
    title: "Utils",
    subMenu: [
      { title: "Modal", link: "/modal" },
      { title: "Drawer", link: "/drawer" },
    ],
  },
  {
    title: "Feedback",
    subMenu: [
      { title: "Alert", link: "/alert" },
      { title: "Snackbar", link: "/snackbar" },
      { title: "Skeleton", link: "/skeleton" },
    ],
  },
  {
    title: "Date & Time Picker",
    subMenu: [
      { title: "Date Picker", link: "/date-picker" },
      { title: "Time Picker", link: "/time-picker" },
    ],
  },
];
